import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import API from '../../API';
import CheckoutForm from "./checkoutForm";



const LeadCheckout = (props) => {
    const stripePromise = loadStripe(API.stripeId);
    return (
        <Elements stripe={stripePromise}>
            <CheckoutForm setServiceAmount={props.setServiceAmount} project_id={props.project_id} />
        </Elements>
    );
}

export default LeadCheckout;